import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

/**
 * FaqAccordion — acordeão acessível para perguntas frequentes.
 * Estilizado via `sx` do MUI consumindo apenas tokens var(--nx-*).
 *
 * @param {Array<{question: string, answer: string}>} items - Pares pergunta/resposta
 */
const FaqAccordion = ({ items }) => (
  <div>
    {items.map((item, i) => (
      <Accordion
        key={i}
        disableGutters
        sx={{
          marginBottom: 'var(--nx-s2)',
          borderRadius: 'var(--nx-r-md) !important',
          border: '1px solid var(--nx-line)',
          '&:before': { display: 'none' },
          boxShadow: 'var(--nx-sh-sm)',
          '&.Mui-expanded': {
            boxShadow: 'var(--nx-sh-md)',
            borderColor: 'var(--nx-primary)',
          },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon sx={{ color: 'var(--nx-primary)' }} />}
          sx={{
            borderRadius: 'var(--nx-r-md)',
            '& .MuiAccordionSummary-content': { margin: 'var(--nx-s3) 0' },
            '&:focus-visible': {
              outline: '3px solid var(--nx-primary)',
              outlineOffset: '2px',
            },
          }}
        >
          <h3
            style={{
              margin: 0,
              fontSize: 'var(--nx-fs-h3)',
              fontWeight: 700,
              color: 'var(--nx-primary-700)',
              fontFamily: 'var(--nx-font-head)',
            }}
          >
            {item.question}
          </h3>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingTop: 0 }}>
          <p
            style={{
              margin: 0,
              color: 'var(--nx-text)',
              lineHeight: 1.6,
              fontSize: 'var(--nx-fs-body)',
            }}
          >
            {item.answer}
          </p>
        </AccordionDetails>
      </Accordion>
    ))}
  </div>
);

export default FaqAccordion;
